"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINDatePicker = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_date_picker_1 = __importDefault(require("react-date-picker"));
var moment_1 = __importDefault(require("moment"));
var react_2 = require("@iconify/react");
function PINDatePicker(_a) {
    var value = _a.value, onChange = _a.onChange, className = _a.className, allowClear = _a.allowClear;
    return (react_1.default.createElement(react_date_picker_1.default, { className: "pin-date-picker " + (className !== null && className !== void 0 ? className : ""), value: value, onChange: onChange, locale: moment_1.default.locale(), showLeadingZeros: true, clearIcon: allowClear ? react_1.default.createElement(react_2.Icon, { icon: "mdi:close", style: { fontSize: "1.9rem" } }) : null, calendarIcon: react_1.default.createElement(react_2.Icon, { icon: "mdi:calendar-month", style: { fontSize: "1.9rem" } }) }));
}
exports.PINDatePicker = PINDatePicker;
PINDatePicker.propTypes = {
    /** A className that will be added to the wrapping div. */
    className: prop_types_1.default.string,
    /** The date value of the picker. */
    value: prop_types_1.default.instanceOf(Date),
    /** A function that will be call each time the date selection change. */
    onChange: prop_types_1.default.func,
    /** Choose to display a clear button next to the calendar icon. */
    allowClear: prop_types_1.default.bool.isRequired,
};
PINDatePicker.defaultProps = {
    allowClear: false,
};
//# sourceMappingURL=PINDatePicker.js.map